import { bento } from '@tock/tokens';
import { css } from '@emotion/react';

export const fontFamilySansRegular = 'Oracle, Helvetica, sans-serif';
export const fontFamilySansCondensed = "'Söhne Schmal', Helvetica, sans-serif";

export type BentoTypographyVariant =
  | 'decorative'
  | 'heading01'
  | 'heading02'
  | 'heading03'
  | 'heading04'
  | 'overline'
  | 'body'
  | 'bodyStrong'
  | 'caption'
  | 'captionStrong';

/**
 * Typography ramp definitions.
 * Available on theme.typography.variant and implemented in bento/Typography
 */
// NOTE: Eventually this should be a different function that uses variant as the key but that wont work until we align our types here which we have to do at the end.
export const getTypographyVariant = (variant: BentoTypographyVariant) => {
  switch (variant) {
    case 'decorative':
      return css`
        font-family: ${bento.typography.decorative.fontFamily};
        font-size: ${bento.typography.decorative.fontSize};
        line-height: ${bento.typography.decorative.lineHeight};
        text-transform: uppercase;
      `;

    case 'heading01':
      return css`
        font-family: ${bento.typography.heading01.fontFamily};
        font-size: ${bento.typography.heading01.fontSize};
        line-height: ${bento.typography.heading01.lineHeight};
        font-weight: ${bento.typography.heading01.fontWeight};
      `;

    case 'heading02':
      return css`
        font-family: ${bento.typography.heading02.fontFamily};
        font-size: ${bento.typography.heading02.fontSize};
        line-height: ${bento.typography.heading02.lineHeight};
        font-weight: ${bento.typography.heading02.fontWeight};
      `;

    case 'heading03':
      return css`
        font-family: ${bento.typography.heading03.fontFamily};
        font-size: ${bento.typography.heading03.fontSize};
        line-height: ${bento.typography.heading03.lineHeight};
        font-weight: ${bento.typography.heading03.fontWeight};
      `;

    case 'heading04':
      return css`
        font-family: ${bento.typography.heading04.fontFamily};
        font-size: ${bento.typography.heading04.fontSize};
        line-height: ${bento.typography.heading04.lineHeight};
        font-weight: ${bento.typography.heading04.fontWeight};
      `;

    case 'overline':
      return css`
        font-family: ${bento.typography.overline.fontFamily};
        font-size: ${bento.typography.overline.fontSize};
        line-height: ${bento.typography.overline.lineHeight};
        font-weight: ${bento.typography.overline.fontWeight};
        letter-spacing: 1px;
        text-transform: uppercase;
      `;

    case 'body':
      return css`
        font-family: ${bento.typography.body01.fontFamily};
        font-size: ${bento.typography.body01.fontSize};
        line-height: ${bento.typography.body01.lineHeight};
        font-weight: ${bento.typography.body01.fontWeight};
      `;

    case 'bodyStrong':
      return css`
        font-family: ${bento.typography.body01Strong.fontFamily};
        font-size: ${bento.typography.body01Strong.fontSize};
        line-height: ${bento.typography.body01Strong.lineHeight};
        font-weight: ${bento.typography.body01Strong.fontWeight};
      `;

    case 'caption':
      return css`
        font-family: ${bento.typography.caption.fontFamily};
        font-size: ${bento.typography.caption.fontSize};
        line-height: ${bento.typography.caption.lineHeight};
        font-weight: ${bento.typography.caption.fontWeight};
      `;

    case 'captionStrong':
      return css`
        font-family: ${bento.typography.captionStrong.fontFamily};
        font-size: ${bento.typography.captionStrong.fontSize};
        line-height: ${bento.typography.captionStrong.lineHeight};
        font-weight: ${bento.typography.captionStrong.fontWeight};
      `;
  }
};
